import React from 'react';
import { DawidPagination } from './ui/pagination';
import { LOOPS_COMPONENTS_SEPARATOR } from '../utils.js';
import { isDecisionOnlyIteration } from '../items/utils';

export function resolveShortLoopName(loopName, loopsDefinitions) {
  let shortName = loopName.substring(loopName.lastIndexOf(LOOPS_COMPONENTS_SEPARATOR) + 1);
  if (shortName === undefined) shortName = loopName;
  shortName = shortName.substring(0, shortName.lastIndexOf('$')) || shortName;
  if (loopsDefinitions) {
    if (shortName in loopsDefinitions) {
      shortName = loopsDefinitions[shortName]['name'];
    } else {
      shortName = 'Loop ' + shortName;
    }
  }
  return shortName;
}

export function LoopsNavigation({
  currentLoopName,
  loops,
  loopsDefinitions,
  onPageChange,
  getIterationName,
}) {
  const parentLoops = [];
  for (const loopName in loops) {
    if (Object.prototype.hasOwnProperty.call(loops, loopName)) {
      if (loopName !== currentLoopName && currentLoopName.startsWith(loopName)) {
        parentLoops.push(loopName);
      }
    }
  }
  parentLoops.sort();

  const hideIteration = (loopName, iteration) => {
    const loop = loops[loopName];
    if (loop.index - 1 === iteration) return false;
    return isDecisionOnlyIteration(loop, iteration);
  };

  const currentLoop = loops[currentLoopName];
  const shortLoopName = resolveShortLoopName(currentLoopName, loopsDefinitions);
  const loopIndex = currentLoop.index;
  const maxLoopIndex = currentLoop.states.length;
  const validIterations = currentLoop.validIterations;

  return (
    <div className="loopsNavigation space-y-2">
      {parentLoops.map((parentLoopName) => {
        const loopParent = loops[parentLoopName];
        const shortParentLoopName = resolveShortLoopName(parentLoopName, loopsDefinitions);
        return (
          <div key={'parentLoop-' + parentLoopName} className="flex flex-wrap items-center gap-2">
            <DawidPagination
              getIterationName={(iteration) => getIterationName(parentLoopName, iteration)}
              hideIteration={(iteration) => hideIteration(parentLoopName, iteration)}
              activePage={loopParent.index}
              onPageChange={onPageChange}
              totalPages={loopParent.states.length}
              completed={loopParent.validIterations}
              maxLength={10}
            />
            <span className="text-sm text-gray-500">{shortParentLoopName}</span>
          </div>
        );
      })}
      <div className="flex flex-wrap items-center gap-2">
        <DawidPagination
          hideIteration={(iteration) => hideIteration(currentLoopName, iteration)}
          getIterationName={(iteration) => getIterationName(currentLoopName, iteration)}
          activePage={loopIndex}
          onPageChange={onPageChange}
          totalPages={maxLoopIndex}
          completed={validIterations}
          maxLength={10}
        />
        <span className="text-sm text-gray-500">{shortLoopName}</span>
      </div>
    </div>
  );
}
